import { render, staticRenderFns } from "./leftBanner.vue?vue&type=template&id=190e14a3&scoped=true&"
import script from "./leftBanner.vue?vue&type=script&lang=js&"
export * from "./leftBanner.vue?vue&type=script&lang=js&"
import style0 from "./leftBanner.vue?vue&type=style&index=0&id=190e14a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e14a3",
  null
  
)

export default component.exports